<script setup lang="ts">
defineProps<{ id: string; helpText: string }>();
</script>
<template>
  <span :id="id" class="tw-block tw-text-xs tw-text-gray-600">
    {{ helpText }}
  </span>
</template>
